var _excluded = ["analyticsName", "inViewThreshold", "ref"],
    _excluded2 = ["analyticsName", "inViewThreshold"];

function cov_1kt4fvyrry() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Box/Box.tsx";
  var hash = "a8d29fdbd4c84590ca01df60bfbd485ae676935c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Box/Box.tsx",
    statementMap: {
      "0": {
        start: {
          line: 38,
          column: 77
        },
        end: {
          line: 56,
          column: 1
        }
      },
      "1": {
        start: {
          line: 44,
          column: 29
        },
        end: {
          line: 44,
          column: 51
        }
      },
      "2": {
        start: {
          line: 45,
          column: 30
        },
        end: {
          line: 48,
          column: 4
        }
      },
      "3": {
        start: {
          line: 49,
          column: 2
        },
        end: {
          line: 54,
          column: 30
        }
      },
      "4": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 52,
          column: 5
        }
      },
      "5": {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 51,
          column: 70
        }
      },
      "6": {
        start: {
          line: 55,
          column: 2
        },
        end: {
          line: 55,
          column: 93
        }
      },
      "7": {
        start: {
          line: 58,
          column: 12
        },
        end: {
          line: 70,
          column: 2
        }
      },
      "8": {
        start: {
          line: 59,
          column: 2
        },
        end: {
          line: 68,
          column: 3
        }
      },
      "9": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 67,
          column: 6
        }
      },
      "10": {
        start: {
          line: 69,
          column: 2
        },
        end: {
          line: 69,
          column: 68
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 38,
            column: 77
          },
          end: {
            line: 38,
            column: 78
          }
        },
        loc: {
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 56,
            column: 1
          }
        },
        line: 43
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 49,
            column: 12
          },
          end: {
            line: 49,
            column: 13
          }
        },
        loc: {
          start: {
            line: 49,
            column: 18
          },
          end: {
            line: 54,
            column: 3
          }
        },
        line: 49
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 58,
            column: 40
          },
          end: {
            line: 58,
            column: 41
          }
        },
        loc: {
          start: {
            line: 58,
            column: 95
          },
          end: {
            line: 70,
            column: 1
          }
        },
        line: 58
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 40,
            column: 21
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 40,
            column: 20
          },
          end: {
            line: 40,
            column: 21
          }
        }],
        line: 40
      },
      "1": {
        loc: {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 50
      },
      "2": {
        loc: {
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 68,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 68,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 59
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a8d29fdbd4c84590ca01df60bfbd485ae676935c"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1kt4fvyrry = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1kt4fvyrry();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { forwardRef } from '@chakra-ui/system';
import { useMergeRefs } from '@chakra-ui/hooks';
import { useObservabilitySafe } from '../../hooks/useObservabilitySafe';
import { bricks } from '../../system/bricks.types';
/**
 * NOTE ABOUT METRIC TRACKING: Box is set up to track impression events
 * It will only track impression events if:
 *  1) a non-empty analyticsName is passed down - Convention: {appName}-{boxName}
 *  2) box enters viewport (threshold is set at 100% for now.  threshold: Number between 0 and 1 indicates the percentage that should be visible before triggering.)
 *
 * Events will be sent to the journey service and will end up in the corresponding tables (e.g. journey_service_production.box_view_event for box impression events)
 * For more information on tracking please refer here: https://opendoor.atlassian.net/wiki/spaces/SELL/pages/1926201404/EDD+User+Behavior+Metrics+in+Bricks
 */

cov_1kt4fvyrry().s[0]++;

var BoxWithTracking = function BoxWithTracking(_ref) {
  var analyticsName = _ref.analyticsName,
      _ref$inViewThreshold = _ref.inViewThreshold,
      inViewThreshold = _ref$inViewThreshold === void 0 ? (cov_1kt4fvyrry().b[0][0]++, 1) : _ref$inViewThreshold,
      ref = _ref.ref,
      props = _objectWithoutProperties(_ref, _excluded);

  cov_1kt4fvyrry().f[0]++;

  var _ref2 = (cov_1kt4fvyrry().s[1]++, useObservabilitySafe()),
      trackUserEvent = _ref2.trackUserEvent;

  var _ref3 = (cov_1kt4fvyrry().s[2]++, useInView({
    threshold: inViewThreshold,
    skip: !analyticsName
  })),
      _ref4 = _slicedToArray(_ref3, 2),
      inViewRef = _ref4[0],
      inView = _ref4[1];

  cov_1kt4fvyrry().s[3]++;
  useEffect(function () {
    cov_1kt4fvyrry().f[1]++;
    cov_1kt4fvyrry().s[4]++;

    if (inView) {
      cov_1kt4fvyrry().b[1][0]++;
      cov_1kt4fvyrry().s[5]++;
      trackUserEvent({
        boxViewEvent: {
          targetName: analyticsName
        }
      });
    } else {
      cov_1kt4fvyrry().b[1][1]++;
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [inView, analyticsName]);
  cov_1kt4fvyrry().s[6]++;
  return /*#__PURE__*/React.createElement(bricks.div, _extends({
    ref: useMergeRefs(ref, inViewRef),
    boxSizing: "border-box"
  }, props));
};

var Box = (cov_1kt4fvyrry().s[7]++, forwardRef(function (_ref5, ref) {
  var analyticsName = _ref5.analyticsName,
      inViewThreshold = _ref5.inViewThreshold,
      props = _objectWithoutProperties(_ref5, _excluded2);

  cov_1kt4fvyrry().f[2]++;
  cov_1kt4fvyrry().s[8]++;

  if (analyticsName) {
    cov_1kt4fvyrry().b[2][0]++;
    cov_1kt4fvyrry().s[9]++;
    return /*#__PURE__*/React.createElement(BoxWithTracking, _extends({
      analyticsName: analyticsName,
      inViewThreshold: inViewThreshold,
      ref: ref
    }, props));
  } else {
    cov_1kt4fvyrry().b[2][1]++;
  }

  cov_1kt4fvyrry().s[10]++;
  return /*#__PURE__*/React.createElement(bricks.div, _extends({
    ref: ref,
    boxSizing: "border-box"
  }, props));
}));
export default Box;